<template>
  <div :class="{ 'transparent-loader': fullScreen === true, 'loader--full-parent': fullParent }">
    <div class="loader" :class="{ 'loader--sm': size === 'small' }"></div>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'large',
    },
    fullScreen: {
      type: [Boolean, String],
      default: true,
    },
    fullParent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.loader--full-parent {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
